// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__najIb","content":"style_content__tBf7j","text":"style_text__UWRds","frame":"style_frame__fSc8e"};